<template>
    <div>
        商品管理
    </div>
</template>

<script>

export default {
    components:{
    }
}
</script>